<script>
export default {
	props: {
		size: [String, Number],
		width: [String, Number],
		height: [String, Number],
	},
}
</script>
<template>
	<svg :width="size" :height="size" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.5001 32.75L14.9626 30.475C12.0168 27.8208 9.58137 25.5313 7.65637 23.6063C5.73137 21.6813 4.20012 19.9531 3.06262 18.4219C1.92512 16.8906 1.13033 15.4833 0.678247 14.2C0.226164 12.9167 0.00012207 11.6042 0.00012207 10.2625C0.00012207 7.52084 0.918872 5.23126 2.75637 3.39376C4.59387 1.55626 6.88346 0.637512 9.62512 0.637512C11.1418 0.637512 12.5855 0.958346 13.9564 1.60001C15.3272 2.24168 16.5085 3.14585 17.5001 4.31251C18.4918 3.14585 19.673 2.24168 21.0439 1.60001C22.4147 0.958346 23.8585 0.637512 25.3751 0.637512C28.1168 0.637512 30.4064 1.55626 32.2439 3.39376C34.0814 5.23126 35.0001 7.52084 35.0001 10.2625C35.0001 11.6042 34.7741 12.9167 34.322 14.2C33.8699 15.4833 33.0751 16.8906 31.9376 18.4219C30.8001 19.9531 29.2689 21.6813 27.3439 23.6063C25.4189 25.5313 22.9835 27.8208 20.0376 30.475L17.5001 32.75Z"
			fill="white"
		/>
	</svg>
</template>

